import { AnalysisConversationPanel } from './analysis-conversation-panel'
import { ImpactDetailAside } from './impact-detail-aside'
import { SidePanel } from './side-panel'
import type { useMaintenanceSession } from './use-maintenance-session'

type MaintenanceSession = ReturnType<typeof useMaintenanceSession>

/** 유지하기 분석 화면의 좌측 이력, 중앙 대화, 우측 상세 패널을 배치한다. */
export function MaintenanceAnalysisWorkspace({
    session,
}: {
    session: MaintenanceSession
}) {
    const {
        assessments,
        selectedId,
        setSelectedId,
        description,
        setDescription,
        submittedText,
        history,
        checklist,
        selectedEventId,
        setSelectedEventId,
        setSelectedImpactId,
        pendingClarification,
        progress,
        actionError,
        submitting,
        textareaRef,
        selectedAssessment,
        activeEvent,
        resultItems,
        recheckCount,
        keepCount,
        unaffectedCount,
        selectedImpact,
        handleSubmit,
        handleDescriptionKeyDown,
        submitClarificationAnswers,
        focusNewChange,
        copyRecheckItems,
        openImpactReport,
    } = session

    if (!assessments) return null

    return (
        <div
            className={`grid min-h-0 flex-1 gap-5 max-lg:grid-cols-1 ${
                activeEvent
                    ? 'grid-cols-[280px_minmax(0,1fr)_360px] max-xl:grid-cols-[minmax(0,1fr)_340px]'
                    : 'grid-cols-[320px_minmax(0,1fr)]'
            }`}>
            <SidePanel
                assessments={assessments}
                selectedAssessment={selectedAssessment}
                selectedId={selectedId}
                onSelect={setSelectedId}
                history={history}
                selectedEventId={selectedEventId}
                onSelectEvent={setSelectedEventId}
                onNewChange={focusNewChange}
            />
            <AnalysisConversationPanel
                assessments={assessments}
                selectedId={selectedId}
                selectedAssessment={selectedAssessment}
                description={description}
                submittedText={submittedText}
                pendingClarification={pendingClarification}
                progress={progress}
                actionError={actionError}
                submitting={submitting}
                textareaRef={textareaRef}
                activeEvent={activeEvent}
                history={history}
                resultItems={resultItems}
                checklistCount={checklist.length}
                onSelectAssessment={setSelectedId}
                onDescriptionChange={setDescription}
                onSubmit={handleSubmit}
                onDescriptionKeyDown={handleDescriptionKeyDown}
                onSubmitClarification={submitClarificationAnswers}
                onSelectImpact={setSelectedImpactId}
                onCopyRecheckItems={copyRecheckItems}
                onOpenReport={openImpactReport}
            />

            {activeEvent ? (
                <ImpactDetailAside
                    activeEvent={activeEvent}
                    checklist={checklist}
                    resultItems={resultItems}
                    selectedImpact={selectedImpact}
                    recheckCount={recheckCount}
                    keepCount={keepCount}
                    unaffectedCount={unaffectedCount}
                    onSelectImpact={setSelectedImpactId}
                />
            ) : null}
        </div>
    )
}
